import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { ReportTable } from '../components/ReportTable';
import { Loader2, Download, Printer, FileBarChart2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function SharedReportPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    axios.get(`${API}/reports/shared/${token}`)
      .then(r => setData(r.data))
      .catch(e => setError(e.response?.data?.detail || 'This report link is invalid'));
  }, [token]);

  if (error) return <div className="min-h-screen flex items-center justify-center text-muted-foreground text-sm">{error}</div>;
  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-muted-foreground" /></div>;

  const dl = (format) => {
    const qs = new URLSearchParams({ report: data.report, event_id: data.event.event_id, format, token,
      date_from: data.date_from || '', date_to: data.date_to || '' });
    window.open(`${API}/reports/export?${qs}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-background pt-20 pb-12 px-4" data-testid="shared-report-page">
      <div className="max-w-6xl mx-auto space-y-4">
        <div className="flex flex-wrap items-start justify-between gap-3 print:hidden">
          <div>
            <p className="text-[11px] uppercase tracking-[0.25em] font-bold text-indigo-400 flex items-center gap-1.5">
              <FileBarChart2 className="h-3.5 w-3.5" /> Eventism partner report
            </p>
            <h1 className="text-xl font-bold mt-1">{data.event?.name} — {data.label}</h1>
            <p className="text-xs text-muted-foreground">{data.description} · live data, refreshed every time you open this link</p>
          </div>
          <div className="flex gap-1.5">
            <Button size="sm" variant="outline" onClick={() => dl('csv')} data-testid="shared-export-csv"><Download className="h-3.5 w-3.5 mr-1" /> CSV</Button>
            <Button size="sm" variant="outline" onClick={() => dl('xlsx')} data-testid="shared-export-xlsx"><Download className="h-3.5 w-3.5 mr-1" /> Excel</Button>
            <Button size="sm" variant="outline" onClick={() => window.print()} data-testid="shared-print"><Printer className="h-3.5 w-3.5 mr-1" /> Print / PDF</Button>
          </div>
        </div>
        <ReportTable data={data} />
      </div>
    </div>
  );
}
